import script from "./PdfViewerContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfViewerContainer.vue?vue&type=script&setup=true&lang=js"

import "./PdfViewerContainer.vue?vue&type=style&index=0&id=04607e04&scoped=true&lang=scss"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04607e04"]])

export default __exports__